import { cn } from "@/utils/helpers"

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  helperText?: string
}

export function Input({
  label,
  error,
  helperText,
  className,
  ...props
}: InputProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-xs font-semibold text-ink mb-1.5">
          {label}
        </label>
      )}
      <input
        className={cn(
          "w-full rounded-2xl border border-black/8 bg-white px-4 py-3 text-base text-ink placeholder:text-muted/70 transition-all focus:border-black/20 focus:ring-2 focus:ring-black/5 focus:outline-none",
          error && "border-red-500 focus:border-red-500 focus:ring-red-100",
          className
        )}
        style={{
          WebkitAppearance: props.type === 'number' ? 'textfield' : undefined,
          MozAppearance: props.type === 'number' ? 'textfield' : undefined,
        }}
        {...props}
      />
      <p className={`mt-1.5 min-h-[1.25rem] text-xs ${error ? 'text-red-600' : 'text-muted'}`}>
        {error || helperText || '\u00A0'}
      </p>
    </div>
  )
}
